const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchidektLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "master-artboard",
    viewBox: "0 0 950 950",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 336 235.2"
    },
    width: "950px",
    height: "950px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-0",
    gradientUnits: "userSpaceOnUse",
    x1: 241.23670959472656,
    y1: 675.8709716796875,
    x2: 241.2366943359375,
    y2: 775.8711547851562,
    gradientTransform: "matrix(-0.0012654108336507082, -0.9999988372294004, 0.006346425990591944, -0.000008110346212444417, 229.71793987454365, 776.5607023864759)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(247, 156, 0)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(255, 169, 10)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-1",
    gradientUnits: "userSpaceOnUse",
    x1: 234,
    y1: 471,
    x2: 234,
    y2: 571,
    gradientTransform: "matrix(0.8571050687018336, -0.5151431077287489, 0.008199151115054091, 0.013641669454558211, 45.24361297460119, 624.6304983465637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(203, 203, 203)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-2",
    gradientUnits: "userSpaceOnUse",
    x1: 234,
    y1: 471,
    x2: 234,
    y2: 571,
    gradientTransform: "matrix(0.8687092020762066, 0.49532353673751117, -0.006038381628750358, 0.010590204001014172, 18.555517463961007, 390.18394190077277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(41, 41, 41)"
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "ee-background",
    x: 0,
    y: 0,
    width: 950,
    height: 950,
    style: {
      fill: "white",
      fillOpacity: 0,
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-4.8999924659729, 0.008858803659677505, -0.008858803659677505, -4.8999924659729, 1846.5793449325784, 3187.4970451598238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-1",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277,546l-43,25l-43-25v-50l43-25l43,25V546z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-4.182153701782227, 0.007560909725725653, -0.007560909725725653, -4.182153701782227, 1677.7490226669538, 2814.728490472323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-3",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277,546l-43,25l-43-25v-50l43-25l43,25V546z",
    style: {
      fill: "url('#gradient-2')"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-4.8999924659729, 0.008858803659677505, -0.008858803659677505, -4.8999924659729, 1635.6136466903913, 2824.5324455504488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-5",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277,546l-43,25l-43-25v-50l43-25l43,25V546z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-4.182153701782227, 0.007560910191386938, -0.007560910191386938, -4.182153701782227, 1466.783203125, 2451.7641601562505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-7",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277,546l-43,25l-43-25v-50l43-25l43,25V546z",
    style: {
      fill: "url('#gradient-0')"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 231.05662536621094 540.0606079101562",
    style: {
      fill: "rgb(247, 156, 1)",
      fillOpacity: 1,
      stroke: "rgb(0, 0, 0)",
      strokeOpacity: 1,
      strokeWidth: 0,
      paintOrder: "fill"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-4.8999924659729, 0.008858803659677505, -0.008858803659677505, -4.8999924659729, 1427.6663810653913, 3188.1803947691988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-9",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277,546l-43,25l-43-25v-50l43-25l43,25V546z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-4.182153701782227, 0.007560909725725653, -0.007560909725725653, -4.182153701782227, 1258.8360587997663, 2815.412572503573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-11",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277,546l-43,25l-43-25v-50l43-25l43,25V546z",
    style: {
      fill: "url('#gradient-1')"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-4.8999924659729, 0.008858803659677505, -0.008858803659677505, -4.8999924659729, 1634.0981437607038, 3067.1901603941988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-13",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277,546l-43,25l-43-25v-50l43-25l43,25V546z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-4.182153701782227, 0.007560909725725653, -0.007560909725725653, -4.182153701782227, 1465.2679435653918, 2694.4216057066988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-15",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277,546l-43,25l-43-25v-50l43-25l43,25V546z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchidektLogo);
export default __webpack_public_path__ + "static/media/archidekt_logo.d6005e48dac79437137201865a204707.svg";
export { ForwardRef as ReactComponent };